export const environment = {
  production: true,
  apiBaseUrl: "https://api.strangeryap.fun",
  socketUrl: "https://api.strangeryap.fun/realtime",
  videoSocketUrl: "https://api.strangeryap.fun/video",
};
